import styled from 'styled-components';
import { colors } from 'utils/generate-theme';
import { formatViewport } from 'utils/get-pixels-to-viewport';
import { overflowScrollAnimation } from 'utils/overflow-scroll-animation';

import { NEIGHBOURHOOD_PERK_DESCRIPTION_LINES } from 'components/widgets/widget-neighbourhood-perks/constants';

const DESCRIPTION_LINE_HEIGHT = 16 / 12;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border: ${formatViewport(1)} solid ${({ theme }) => theme.border.primary};
  border-radius: 2%;
  overflow: hidden;
`;

export const ImageContainer = styled.div`
  /* Fixed share of the card — the description must never be able to squash the image. */
  flex: 0 0 75%;
  height: 75%;
  width: 100%;
  display: flex;
  position: relative;
  overflow: hidden;
`;

export const Image = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

export const LogoContainer = styled.div`
  position: absolute;
  bottom: ${formatViewport(10)};
  left: ${formatViewport(10)};
  width: 20%;
  aspect-ratio: 16/9;

  max-height: 70%;
`;

export const Logo = styled.img`
  object-fit: contain;
  object-position: bottom left;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

export const Tag = styled.div`
  position: absolute;
  bottom: ${formatViewport(10)};
  right: ${formatViewport(10)};
  max-width: 60%;
  padding: ${formatViewport(6)} ${formatViewport(16)};
  border-radius: ${formatViewport(50)};
  background-color: ${colors.lightGreen};
  color: ${colors.green};
  font-size: ${formatViewport(14)};
  line-height: ${formatViewport(20)};
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const InfoContainer = styled.div`
  /* The rest of the card, regardless of how long the description is. */
  flex: 0 0 25%;
  height: 25%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: ${formatViewport(8)} ${formatViewport(16)};
  overflow: hidden;
  color: ${({ theme }) => theme.text.primary};
`;

export const Title = styled.div`
  flex-shrink: 0;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: ${formatViewport(20)};
  line-height: ${formatViewport(28)};
`;

export const Description = styled.div`
  flex-shrink: 0;
  margin-top: ${formatViewport(4)};
  font-size: ${formatViewport(12)};
  line-height: ${DESCRIPTION_LINE_HEIGHT};
  max-height: ${NEIGHBOURHOOD_PERK_DESCRIPTION_LINES * DESCRIPTION_LINE_HEIGHT}em;
  overflow: hidden;
`;

export const DescriptionText = styled.span<{ $isScrolling: boolean }>`
  display: block;
  overflow-wrap: anywhere;

  ${({ $isScrolling }) => $isScrolling && overflowScrollAnimation('vertical')}
`;
